<div class="card-ticket">
    <div class="ticekts-active-state--accent" *ngIf="label">
        {{ label }}
    </div>
    <div class="single-ticket">
        <div class="single-ticket__content">
            <div class="border-line" [ngClass]="{ 'renew': isPending }"></div>

            <div class="single-ticket__top-content">
                <ng-content select="[header]"></ng-content>
            </div>
            <ng-content></ng-content>
        </div>
        <div class="single-ticket-notification" *ngIf="notification">
            {{ notification }}
        </div>
    </div>
</div>
